// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Anastasia Chesnovskaya <anastasia.chesnovskaya@celadon.ae>

import GlobalStyles from '../../../../config/styles';

const styles = theme => ({
  paymentMethodText: {
    fontSize: GlobalStyles.fonts.FONT_SIZE_LARGE,
    letterSpacing: 1.1,
    marginLeft: 20,
    [theme.breakpoints.down(450)]: {
      fontSize: GlobalStyles.fonts.FONT_SIZE,
    }
  },
  paymentMethodTextNoMargin: {
    marginLeft: 0,
  },
  voucherPriceText: {
    color: GlobalStyles.color.COLOR_SECONDARY,
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_BOLD,
  },
  infoContainer: {
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_REGULAR,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'left',
    margin: '0 40px',
    [theme.breakpoints.down(450)]: {
      maxWidth: 200,
    }
  },
  linkText: {
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_BOLD,
    fontSize: GlobalStyles.fonts.FONT_SIZE_LARGE,
    textAlign: 'justify',
    color: 'black',
    '&:hover *': {
      color: GlobalStyles.color.COLOR_SECONDARY,
    },
    '&:hover': {
      textDecoration: 'none',
    },
    [theme.breakpoints.down(450)]: {
      fontSize: GlobalStyles.fonts.FONT_SIZE,
    }
  },
  linkText1: {
    color: GlobalStyles.color.COLOR_YELLOW_SELECT,
  },
  subText: {
    textAlign: 'justify',
    fontSize: GlobalStyles.fonts.FONT_SIZE_SMALL,
    color: GlobalStyles.color.COLOR_BLACK_GREY,
    [theme.breakpoints.down(450)]: {
      fontSize: GlobalStyles.fonts.FONT_SIZE_MINI,
    }
  },
  voucherPriceContainer: {
    flexDirection: 'row',
  },
  bottomText: {
    textAlign: 'justify',
    fontSize: GlobalStyles.fonts.FONT_SIZE_SMALL,
    color: GlobalStyles.color.COLOR_BLACK_GREY,
    [theme.breakpoints.down(450)]: {
      fontSize: GlobalStyles.fonts.FONT_SIZE_MINI,
    }
  },
});

export default styles;
